import { render, staticRenderFns } from "./ShareWithFacebookModal.vue?vue&type=template&id=3a6b9b45"
import script from "./ShareWithFacebookModal.vue?vue&type=script&lang=js"
export * from "./ShareWithFacebookModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports